module.exports = __webpack_public_path__ + "static/media/Profile Picture of Dr. Mohsin Ali Shah (2).359915ac.jpeg";